import styled from 'styled-components';
import { alpha } from '../../themes/brand';

export const Container = styled.div`
  padding: 24px;
  background-color: ${({theme}) => theme.background};
  height: 100%;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    padding: 20px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 16px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 16px;
  }
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin: 0;
  font-size: 32px;
  font-weight: 700;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    font-size: 28px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    font-size: 24px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const ResultsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
  
  @media (max-width: 768px) {
    gap: 12px;
    margin-top: 16px;
  }
  
  @media (max-width: 480px) {
    gap: 10px;
    margin-top: 12px;
  }
`;

export const OperatorRow = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${props => props.theme.text};
  margin-bottom: 8px;
  padding: 8px 12px;
  background-color: ${props => props.theme.backgroundAlt || '${({ theme }) => alpha(theme.primary, 0.05)}'};
  border-radius: 6px;
  
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 10px 16px;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 4px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    padding: 8px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
`;

export const OperatorIcon = styled.span`
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: ${props => props.theme.text};
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    margin-right: 6px;
  }
  
  @media (max-width: 480px) {
    margin-right: 4px;
    width: 18px;
    height: 18px;
  }
`;

export const OperatorLabel = styled.span`
  font-weight: 600;
  margin-right: 8px;
  
  @media (max-width: 768px) {
    margin-right: 6px;
  }
  
  @media (max-width: 480px) {
    margin-right: 4px;
    display: block;
    margin-bottom: 2px;
  }
`;

export const OperatorName = styled.span`
  font-weight: 400;
  
  @media (max-width: 480px) {
    padding-left: 22px;
  }
`;

export const ResultItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.usersDivBackground};
  padding: 16px;
  border-radius: 10px;
  color: ${props => props.theme.text};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
  gap: 16px;
  min-height: 80px;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    padding: 14px;
    gap: 12px;
    font-size: 15px;
    flex-wrap: wrap;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    gap: 12px;
    min-height: auto;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 12px;
    font-size: 14px;
    gap: 8px;
  }
`;

export const DateTimeColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 120px;
  min-width: 120px;
  padding: 10px;
  border-right: 1px solid ${props => props.theme.border};
  flex-shrink: 0;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    width: 100px;
    min-width: 100px;
    padding: 8px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
    padding: 0;
    border-right: none;
    border-bottom: 1px solid ${props => props.theme.border};
    padding-bottom: 8px;
    align-items: flex-start;
    flex-direction: row;
    gap: 8px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const Date = styled.div`
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 4px;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    font-size: 16px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 0;
    
    &::before {
      content: 'Data: ';
      font-weight: 500;
      color: ${props => props.theme.textSecondary || props.theme.placeholderColor};
    }
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    font-size: 14px;
    margin-bottom: 2px;
    
    &::before {
      display: block;
      margin-bottom: 2px;
    }
  }
`;

export const Time = styled.div`
  font-size: 16px;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    font-size: 14px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    font-size: 14px;
    
    &::before {
      content: 'Hora: ';
      font-weight: 500;
      color: ${props => props.theme.textSecondary || props.theme.placeholderColor};
    }
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const ClientColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 230px;
  min-width: 230px;
  padding: 10px 16px;
  border-right: 1px solid ${props => props.theme.border};

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    width: 200px;
    min-width: 200px;
    padding: 8px 12px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
    padding: 8px 0;
    border-right: none;
    border-bottom: 1px solid ${props => props.theme.border};
    padding-bottom: 8px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 6px 0;
  }
`;

export const ClientTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
  
  @media (max-width: 768px) {
    font-size: 14px;
    color: ${props => props.theme.textSecondary || props.theme.placeholderColor};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
    margin-bottom: 4px;
  }
`;

export const ClientText = styled.div`
  font-weight: 400;
  
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
  }
  
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const OperatorColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  min-width: 200px;
  padding: 10px 16px;
  border-right: 1px solid ${props => props.theme.border};
`;

export const OperatorTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const OperatorText = styled.div`
  font-weight: 400;
`;

export const ContentColumn = styled.div`
  flex: 1;
  padding: 10px 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    padding: 8px 12px;
    font-size: 14px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 100%;
    padding: 8px 0;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    word-break: break-word;
    line-height: 1.4;
    max-height: 60px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 6px 0;
    font-size: 13px;
    max-height: 45px;
    -webkit-line-clamp: 2;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 12px;
  padding: 0 10px;
  flex-shrink: 0;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    gap: 8px;
    padding: 0 8px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    padding: 8px 0 0 0;
    gap: 16px;
    border-top: 1px solid ${props => props.theme.border};
    padding-top: 12px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    gap: 12px;
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  border-radius: 6px;
  min-width: 36px;
  min-height: 36px;

  &:hover {
    opacity: 0.8;
    background-color: ${({ theme }) => alpha(theme.primary, 0.1)};
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 10px;
    min-width: 44px;
    min-height: 44px;
    border-radius: 8px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 12px;
    min-width: 48px;
    min-height: 48px;
  }
`;

export const ViewButton = styled(IconButton)`
  color: ${({ theme }) => theme.primaryAccent};
`;

export const DownloadButton = styled(IconButton)`
  color: ${({ theme }) => theme.primaryAccent};
`;

export const CopyButton = styled(IconButton)`
  color: ${({ theme }) => theme.primaryAccent};
`;

export const ChatButton = styled(IconButton)`
  color: ${({ theme }) => theme.primaryAccent};
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${({theme}) => theme.deleteModalBackground};
  border-radius: 8px;
  border: 1px solid ${({theme}) => theme.deleteModalBorder};
  padding: 24px;
  width: 750px;
  max-width: 90%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  max-height: 90vh;
  overflow-y: auto;
  
  h3 {
    color: ${({theme}) => theme.text};
    margin-bottom: 16px;
    font-size: 18px;
  }
  
  p {
    margin-bottom: 24px;
    line-height: 1.5;
    color: ${({theme}) => theme.text};
  }

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    width: 90%;
    max-width: 600px;
    padding: 20px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    width: 95%;
    max-width: none;
    padding: 20px;
    border-radius: 12px;
    max-height: 95vh;
    
    h3 {
      font-size: 16px;
      margin-bottom: 12px;
    }
    
    p {
      margin-bottom: 20px;
      font-size: 14px;
    }
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    padding: 16px;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 8px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    margin-top: auto;
    padding-top: 20px;
  }
`;

export const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 14px;
  min-height: 36px;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 16px;
    min-height: 44px;
    width: 100%;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    min-height: 48px;
  }
`;

export const CancelButton = styled(Button)`
  border: 1px solid ${({theme}) => theme.border};
  background-color: ${({theme}) => theme.backgroundCancelButtonDeleteModal};
  color: ${({theme}) => theme.text};
  
  &:hover {
    background-color: ${({theme}) => theme.hoverCancelButtonDeleteModal};
  }
`;

export const ConfirmButton = styled(Button)`
  border: none;
  background-color: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primaryOn};
  
  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }
`;

export const ResultDetails = styled.div`
  padding: 20px;
  background-color: ${({theme}) => theme.usersDivBackground};
  border-radius: 8px;
  margin-top: 16px;
  white-space: pre-wrap;
  max-height: 400px;
  overflow-y: auto;
  margin-bottom: 10px;
  flex: 1;

  /* Responsividade para tablets */
  @media (max-width: 1024px) {
    padding: 16px;
    max-height: 350px;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    padding: 16px;
    margin-top: 12px;
    margin-bottom: 16px;
    max-height: 300px;
    font-size: 14px;
    line-height: 1.4;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    padding: 12px;
    max-height: 250px;
    font-size: 13px;
    flex: 1;
    overflow-y: auto;
  }
`;

export const ResultDetailRow = styled.div`
  margin-bottom: 12px;
  display: flex;
  
  &:last-child {
    margin-bottom: 0;
  }

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 16px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    margin-bottom: 12px;
  }
`;

export const ResultDetailLabel = styled.div`
  font-weight: 600;
  min-width: 120px;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    min-width: auto;
    margin-bottom: 4px;
    font-size: 14px;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const ResultDetailValue = styled.div`
  flex: 1;
  word-break: break-word;

  /* Responsividade para mobile */
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.4;
  }

  /* Mobile pequeno */
  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const Toast = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: ${({ theme }) => theme.success};
  color: ${({ theme }) => theme.successOn};
  padding: 12px 24px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 1100;
  animation: fadeIn 0.3s ease-out forwards, fadeOut 0.3s ease-out 2.7s forwards;
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  @keyframes fadeOut {
    from { opacity: 1; transform: translateY(0); }
    to { opacity: 0; transform: translateY(20px); }
  }
  
  @media (max-width: 768px) {
    bottom: 16px;
    right: 16px;
    left: 16px;
    padding: 14px 20px;
    border-radius: 8px;
    font-size: 14px;
    text-align: center;
  }
  
  @media (max-width: 480px) {
    bottom: 12px;
    right: 12px;
    left: 12px;
    padding: 12px 16px;
    font-size: 13px;
  }
`; 